import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { EstructuraFisicaAgricola } from '../_models/estructura-fisica-agricola';
import {EstructuraAgricola} from '../_models/estructura-agricola';

@Injectable({
  providedIn: 'root'
})
export class EstructuraFisicaAgricolaService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/estructurasFisicasAgricolas/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as EstructuraFisicaAgricola[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as EstructuraFisicaAgricola ) );
  }
  listadoPorEstructuraFisica( id: string ) {
    return this.httpClient.get( this.rutServicio+'estructuraFisica/' + id ).pipe( map( res => res as EstructuraFisicaAgricola[] ) );
  }

  crear( regCrear: EstructuraFisicaAgricola ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as EstructuraFisicaAgricola ) );
  }

  actualizar( regActualizar: EstructuraFisicaAgricola ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }


  bulk( regActualizar: EstructuraFisicaAgricola[] ) {
    regActualizar.map( ( s: EstructuraFisicaAgricola ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as EstructuraFisicaAgricola[] ) );
  }

  listadoPorEstructuraFisicaHabilitadas(idEstructuraFisica: string, estructuraAgricola: EstructuraAgricola[]) {
    return this.httpClient
      .post(
        this.rutServicio + 'estructuraFisica/' + idEstructuraFisica + '/estructuraAgricola/idListIn/enabled',
        estructuraAgricola
      )
      .pipe(map((res) => res as EstructuraFisicaAgricola[]));
  }
}
